export default __webpack_public_path__ + "static/media/logo-albarans.b82c26c5.png";